export default "/static/pf_400_tiny.png";